import React, { useState, useEffect } from "react";
import style from "./topHeaderSliderChange.module.css";
import PageHeader from "../pageHeader/PageHeader";
import Layout from "../layout/Layout";
import { useNavigate } from "react-router";
import BackImg from "../../assets/icons8-back-24.png";
import UploadImage from "../uploadImage/UploadImage";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ImgCrop from "antd-img-crop";
import {
  topHeaderSliderDataAdded,
  topHeaderSliderDataUpdate,
  topHeaderSliderEditAction,
} from "../../store/slices/topHeaderSliderSlice";
import { activeManageAction } from "../../store/slices/settingsSlice";
import SmallLoader from "../smallLoader/SmallLoader";
import { getToken, trelifImageUpload, mainUrl } from "../../utils/common";
import DeleteImg from "../../assets/icons8-delete-24 .png";
import {
  Form,
  Input,
  Radio,
  Select,
  DatePicker,
  Row,
  Spin,
  Upload,
  Col,
  Button,
  AutoComplete,
  InputNumber,
  message,
  Divider,
  TimePicker,
} from "antd";
import BackButton from "../backButton/BackButton";
const { TextArea } = Input;

const TopHeaderSliderChange = () => {
  const path = window.location.pathname;
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.topHeaderSlider.deleteLoad);
  const message = useSelector((state) => state.topHeaderSlider.message);
  // const image = useSelector((state) => state.topHeaderSlider.image);
  const singleTopHeaderSlider = useSelector(
    (state) => state.topHeaderSlider.singleTopHeaderSlider
  );
  const editData = useSelector((state) => state.topHeaderSlider.editData);
  const [form] = Form.useForm();
  const urls = "/home/top-header-slider/add-top-header-slider";
  const navigate = useNavigate();
  const [image, setImage] = useState("");
  const [newImage, setNewImage] = useState("");
  const [addNewImage, setAddNewImage] = useState("");
  const [sliderImage, setSliderImage] = useState("");
  const [newSliderImage, setNewSliderImage] = useState("");
  const [addNewSliderImage, setAddNewSliderImage] = useState("");

  useEffect(() => {
      setAddNewImage("");
      setAddNewSliderImage("");
  }, []);

  const propsUpload = {
    name: "image",
    onChange(info) {
      if (info.file.status !== "uploading") {
      }
      if (info.file.status === "done") {
        setImage(info?.file?.response?.data?.image.toString());
        setNewImage(info?.file?.response?.data?.image.toString());
        setAddNewImage(info?.file?.response?.data?.image.toString());
      }
    },
  };

  const propsUploadSlider = {
    name: "image",
    onChange(info) {
      if (info.file.status === "done") {
        setSliderImage(info?.file?.response?.data?.image.toString());
        setNewSliderImage(info?.file?.response?.data?.image.toString());
        setAddNewSliderImage(info?.file?.response?.data?.image.toString());
      }
    },
  };

  const backHandler = () => {
    dispatch(activeManageAction(2));
    navigate("/home");
  };
  const onFinish = (values) => {
    let data = {
      ...values,
      image: newImage ? newImage : image,
      sliderImage: newSliderImage ? newSliderImage : sliderImage,
    };

    let datas = {
      ...values,
      image: addNewImage,
      sliderImage: addNewSliderImage,
    };

    if (path === urls) {
      dispatch(topHeaderSliderDataAdded(datas));
    } else {
      let idData = path.split("/");
      let id = idData[idData.length - 1];
      dispatch(
        topHeaderSliderDataUpdate(
          singleTopHeaderSlider[0]?._id ? singleTopHeaderSlider[0]?._id : id,
          data
        )
      );
    }
  };

  const onFinishFailed = (errorInfo) => {};
  useEffect(() => {
    if (
      message === "Top header image added successfully!" ||
      message === "Top header slider updated successfully!"
    ) {
      dispatch(activeManageAction(2));
      navigate("/home");
    }
  }, [message]);

  useEffect(() => {
    let data = singleTopHeaderSlider[0];
    setNewImage(data?.image ? data?.image.toString() : "");
    setNewSliderImage(data?.sliderImage ? data?.sliderImage.toString() : "");
  }, [singleTopHeaderSlider]);

  useEffect(() => {
    if (path === urls) {
    } else {
      let data = path.split("/");
      let id = data[data.length - 1];
      dispatch(topHeaderSliderEditAction(id, "TopHeaderSlider"));
    }
  }, []);

  useEffect(() => {
    let data = editData;
    setNewImage(data?.image);
    setNewSliderImage(data?.sliderImage);
  }, [editData]);

  const deleteImgHandler = () => {
    setNewImage("");
  };
  const deleteImgHandlerAdd = () => {
    setAddNewImage("");
  };

  const deleteSliderImgHandler = () => {
    setNewSliderImage("");
  };
  const deleteSliderImgHandlerAdd = () => {
    setAddNewSliderImage("");
  };

  return (
    <>
      <Layout>
        <div className={style.blogChange_section}>
          <BackButton
            name={
              path === urls
                ? "top header slider add"
                : "top header slider update"
            }
            backButtonHandler={backHandler}
          />
          <Form
            className={style.appointments_form}
            name="basic"
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout={"vertical"}
            form={form}
            style={{
              maxWidth: "100%",
            }}
          >
            <div className={style.images_dimensions}>
              the image dimensions should be (1920px)x(1283px).
            </div>
            <Form.Item
              className={style.appointments_form_item_img}
              style={{
                background: "#fff",
                borderRadius: "7px",
                paddingLeft: "5px",
                width: "100%",
              }}
              label="Top Header Image"
              name="image"
            >
              {path === urls ? (
                <>
                  {addNewImage ? (
                    <div className={style.common_edit_image_antd}>
                      <div className={style.common_edit_image_antd_container}>
                        <img
                          src={
                            addNewImage ? `${mainUrl()}/${addNewImage}` : "-"
                          }
                          alt="edit "
                        />
                        <div className={style.common_edit_delt_antd}>
                          <img
                            src={DeleteImg}
                            alt="delete "
                            onClick={deleteImgHandlerAdd}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {addNewImage ? (
                    ""
                  ) : (
                    <Upload
                      action={trelifImageUpload}
                      listType="picture-card"
                      showUploadList={false}
                      onPreview={() => {}}
                      {...propsUpload}
                      headers={{
                        Authorization: `Bearer ${getToken()}`,
                      }}
                    >
                      + Upload
                    </Upload>
                  )}
                </>
              ) : (
                <>
                  {newImage ? (
                    <div className={style.common_edit_image_antd}>
                      <div className={style.common_edit_image_antd_container}>
                        <img
                          src={newImage ? `${mainUrl()}/${newImage}` : "-"}
                          alt="edit"
                        />
                        <div className={style.common_edit_delt_antd}>
                          <img
                            src={DeleteImg}
                            alt="delete"
                            onClick={deleteImgHandler}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <Upload
                    action={trelifImageUpload}
                    listType="picture-card"
                    showUploadList={false}
                    onPreview={() => {}}
                    {...propsUpload}
                    headers={{
                      Authorization: `Bearer ${getToken()}`,
                    }}
                  >
                    {newImage?.length < 1 && "+ Upload"}
                  </Upload>
                </>
              )}
            </Form.Item>

            <Form.Item
              className={style.appointments_form_item_img}
              style={{
                background: "#fff",
                borderRadius: "7px",
                paddingLeft: "5px",
                width: "100%",
              }}
              label="Header Slider filled Image"
              name="sliderImage"
            >
              {path === urls ? (
                <>
                  {addNewSliderImage ? (
                    <div className={style.common_edit_image_antd}>
                      <div className={style.common_edit_image_antd_container}>
                        <img
                          src={
                            addNewSliderImage
                              ? `${mainUrl()}/${addNewSliderImage}`
                              : "-"
                          }
                          alt="edit slider"
                        />
                        <div className={style.common_edit_delt_antd}>
                          <img
                            src={DeleteImg}
                            alt="delete slider"
                            onClick={deleteSliderImgHandlerAdd}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  {addNewSliderImage ? (
                    ""
                  ) : (
                    <Upload
                      action={trelifImageUpload}
                      listType="picture-card"
                      showUploadList={false}
                      onPreview={() => {}}
                      {...propsUploadSlider}
                      headers={{
                        Authorization: `Bearer ${getToken()}`,
                      }}
                    >
                      + Upload
                    </Upload>
                  )}
                </>
              ) : (
                <>
                  {newSliderImage ? (
                    <div className={style.common_edit_image_antd}>
                      <div className={style.common_edit_image_antd_container}>
                        <img
                          src={
                            newSliderImage
                              ? `${mainUrl()}/${newSliderImage}`
                              : "-"
                          }
                          alt="edit slider"
                        />
                        <div className={style.common_edit_delt_antd}>
                          <img
                            src={DeleteImg}
                            alt="delete slider"
                            onClick={deleteSliderImgHandler}
                          />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <Upload
                      action={trelifImageUpload}
                      listType="picture-card"
                      showUploadList={false}
                      onPreview={() => {}}
                      {...propsUploadSlider}
                      headers={{
                        Authorization: `Bearer ${getToken()}`,
                      }}
                    >
                      + Upload
                    </Upload>
                  )}
                </>
              )}
            </Form.Item>

            <Form.Item className={style.appointments_form_submit_all}>
              <Button
                className={style.appointments_form_submit}
                // type="primary"
                htmlType="submit"
                style={{ color: "#fff" }}
              >
                {loading ? (
                  <SmallLoader />
                ) : path === urls ? (
                  "add top header slider"
                ) : (
                  "update top header slider"
                )}
              </Button>
            </Form.Item>
          </Form>
        </div>
      </Layout>
    </>
  );
};
export default TopHeaderSliderChange;
